var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnestar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-actions-star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.52784 2.41102C7.57275 2.26858 7.66191 2.14416 7.78236 2.05585C7.90281 1.96754 8.04828 1.91992 8.19764 1.91992C8.34699 1.91992 8.49246 1.96754 8.61291 2.05585C8.73336 2.14416 8.82252 2.26858 8.86743 2.41102L10.077 6.13068H13.9787C14.1334 6.12483 14.2858 6.16979 14.4125 6.25868C14.5393 6.34758 14.6334 6.47552 14.6806 6.62296C14.7278 6.7704 14.7254 6.92924 14.6738 7.0752C14.6222 7.22116 14.5243 7.34621 14.3949 7.43126L11.228 9.72679L12.4375 13.453C12.4854 13.5949 12.4866 13.7484 12.441 13.8911C12.3954 14.0337 12.3054 14.1581 12.1841 14.246C12.0628 14.3339 11.9166 14.3807 11.7668 14.3795C11.617 14.3784 11.4715 14.3295 11.3515 14.2398L8.17813 11.9183L5.01121 14.2203C4.89124 14.31 4.74574 14.3589 4.59596 14.36C4.44619 14.3611 4.29998 14.3143 4.17869 14.2265C4.0574 14.1386 3.96738 14.0142 3.92178 13.8716C3.87618 13.7289 3.87739 13.5754 3.92522 13.4334L5.13477 9.70728L1.96785 7.41175C1.83849 7.3267 1.74054 7.20165 1.68895 7.05569C1.63736 6.90973 1.63498 6.75089 1.68216 6.60345C1.72934 6.45601 1.8235 6.32807 1.95024 6.23917C2.07698 6.15028 2.22934 6.10532 2.38403 6.11117H6.28578L7.52784 2.41102Z",
    fill: "#FBAD39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnestar);
export default __webpack_public_path__ + "static/media/onestar.d5404676a7fe3019c069313578a9b427.svg";
export { ForwardRef as ReactComponent };